import { render, staticRenderFns } from "./ServicesHomeThree.vue?vue&type=template&id=9023b222"
import script from "./ServicesHomeThree.vue?vue&type=script&lang=js"
export * from "./ServicesHomeThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports